import {
  AddOnIcon,
  DeveloperAPIIcon,
  EstimatesIntegrationsIcon,
  FSMIntegrationsIcon,
  IntegrationIcon,
  QBOIcon,
  WebhooksIcon
} from 'assets/icons';
import { IEditModalState, WebhookEventConfig } from './integrations.model';

export enum INTEGRATIONS_CARD_TYPE {
  Quickbooks = 'QuickBooks',
  'Developer API' = 'Developer API',
  Webhooks = 'Developer API',
  Estimates = 'Estimates',
  'Field Service Management' = 'Field Service Management'
}

export enum API_ACTIONS {
  ROTATE = 'Rotate and expire this token',
  EXPIRE = 'Expire token only'
}

export const DEVELOPER_API_TAGS = ['API keys', 'App communication'];

export const WEBHOOKS_TAGS = ['Webhooks', 'App communication'];

export const QBO_TAGS = ['Business', 'Accounting'];

export const ESTIMATES_TAGS = ['Business'];

export enum INTEGRATIONS_ROUTES {
  'Developer API' = 'DEVELOPER_API',
  Webhooks = 'WEBHOOKS',
  'QuickBooks Online' = 'QUICKBOOKS',
  Estimates = 'ESTIMATE_INTEGRATION',
  'Field Serve' = 'FIELD_SERVICE_MANAGEMENT'
}

export const APITokenExpiryAndACL = {
  expiry: 365,
  acl: {
    invoice: 15,
    customer: 15,
    receipt: 15,
    payout: 15,
    team: 15,
    catalog: 15,
    refund: 15,
    job: 15
  }
};

export const WebhookUrlEvents = {
  webhookEvents: {
    paymentCompleted: true,
    paymentRefunded: true,
    paymentDisputed: true
  }
};

export const INTEGRATIONS_CARD_ICONS = {
  'Developer API': DeveloperAPIIcon,
  Webhooks: WebhooksIcon,
  Estimates: EstimatesIntegrationsIcon,
  'Field Serve': FSMIntegrationsIcon
};

export enum WEBHOOK_EVENTS {
  PAYMENT_COMPLETE = 'payment.complete',
  PAYMENT_REFUNDED = 'payment.refunded',
  PAYMENT_DISPUTE = 'dispute.created'
}

export const webhookEventsList: WebhookEventConfig[] = [
  { title: WEBHOOK_EVENTS.PAYMENT_COMPLETE, enabled: true },
  { title: WEBHOOK_EVENTS.PAYMENT_REFUNDED, enabled: true },
  { title: WEBHOOK_EVENTS.PAYMENT_DISPUTE, enabled: true }
];

export enum AccountClassificationTypes {
  REVENUE = 'Revenue',
  EXPENSE = 'Expense'
}

export const editModalInitialState: IEditModalState = { open: false, type: null, accountData: null };

export const QBORecomendedData = {
  name: 'QuickBooks Online',
  description: 'Automatically copy your receipts and fees to your QuickBooks account.',
  icon: QBOIcon,
  tags: QBO_TAGS
};

export const addOnIntegrationType = {
  addOn: { name: 'Add on', Icon: AddOnIcon },
  integrations: {
    name: 'Integrations',
    Icon: IntegrationIcon
  }
};

export const QBOIntegrationsData = {
  name: 'QuickBooks Online',
  description: 'Automatically copy your receipts and fees to your QuickBooks account.',
  icon: QBOIcon
};

export enum INTEGRATION_NAMES {
  'QuickBooks Online' = 'QuickBooks Online',
  'Developer API' = 'Developer API',
  Webhooks = 'Webhooks',
  Estimates = 'Estimates',
  'Field Serve Plus' = 'Field Serve Plus',
  'Field Serve' = 'Field Serve'
}

export const INTEGRATION_TYPES = ['Developer API', 'Webhooks', 'QuickBooks Online'];

export const FSM_INTEGRATION_TYPES = ['Field Serve Plus', 'Field Serve'];

export const ADD_ON_TYPES = ['Estimates', ...FSM_INTEGRATION_TYPES];
